import { render } from "./HeroiconsSolidCurrencyEuro.vue?vue&type=template&id=5e7d2409"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyEuro.vue"]])

export default __exports__